<template>
    <div class="row" v-if="loading">
        <div class="col-md-12">
            <div class="card card-default">
                <div class="card-body">
                    <i class="fa fa-btn fa-spinner fa-spin"></i>
                    {{ __("Loading") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
}
</script>
